
import seo from '~/mixins/seo'
import pwaControl from '~/mixins/pwaControl'
import notifications from '~/mixins/notifications'

export default {
  mixins: [seo, pwaControl, notifications],
}
